import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { jwtDecode } from "jwt-decode";
import userServiceApi from "./userServiceApi";

const getCurrentTime = async () => {
  return new Promise(async (resolve, reject) => {
    const token = sessionStorage.getItem("token");
    const decoded = jwtDecode(token);
    const jwtExpTime = decoded?.exp;
    if (jwtExpTime) {
      const currentTime = moment().add(5, "minutes").unix();
      if (currentTime <= jwtExpTime) {
        resolve(true);
      } else {
        resolve(false);
      }
    } else {
      reject(false);
    }
  });
};

const getToken = async () => {
  try {
    const refreshToken = sessionStorage.getItem("refresh");
    if (refreshToken) {
      const response = await fetch(userServiceApi.refreshToken(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          refreshToken: refreshToken,
        }),
      });
      const dataR = await response.json();
      if (dataR) {
        sessionStorage.setItem("token", dataR.accessToken);
        return dataR.accessToken;
      }
    } else {
      console.log("refresh token not recived");
    }
  } catch (error) {
    console.error(error);
  }
};

axios.interceptors.request.use(
  async (req) => {
    if (sessionStorage.getItem("loginPage") === "true") {
      return req;
    } else {
      const tokenExist = await getCurrentTime();
      if (tokenExist) {
        const token = sessionStorage.getItem("token");
        if (token) {
          req.headers.Authorization = `Bearer ${token}`;
        }
        return req;
      } else {
        const token = await getToken();
        if (token) {
          req.headers.Authorization = `Bearer ${token}`;
        }
        return req;
      }
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {

    if (error.response) {
      if (error.response.status === 401) {
        sessionStorage.clear();
        window.location.reload();
      }
      if (error.response.status === 400) {
        if (error.response.data.error) {
          toast.error(error.response.data.error);
        } else if (error.response.data.message) {
          toast.error(error.response.data.message);
        }
      }
      if (error.response.status === 500) {
        // toast.error("Internal Server Error");
        toast.error(error.response.data);
        // Optionally, you can log the error for further analysis
        // console.error("Internal Server Error:", error.response.data);
      }
    } else if (error.request) {
      // The request was made but no response was received
      // console.error("Network Error:", error.request);
      toast.error("Network Error. Please check your internet connection.");
    } else {
      // Something happened in setting up the request that triggered an Error
      // console.error("Error:", error.message);
      toast.error("An unexpected error occurred.");
    }
    return error;
  }
);

export const postRequest = async (url, data) => {
  try {
    const response = await axios.post(url, data);
    console.log("response in http.js", response);
    if (response?.response?.status === 400) {
      if (response?.data) {
        toast.error(response?.data);
      } else if (response?.data?.message) {
        toast.error(response?.data?.message);
      }
    }
    return response?.data;
  } catch (error) {
    console.error("postRequest error:", error);
    return Promise.reject(error?.response?.data);
  }
};

export const getRequest = async (url) => {
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    return Promise.reject(error.response);
  }
};

export const putRequest = async (url, data) => {
  try {
    const response = await axios.put(url, data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const patchRequest = async (url, data) => {
  try {
    const response = await axios.patch(url, data);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteRequest = async (url, data) => {
  try {
    const response = await axios.delete(url, data);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const API_URL = process.env.REACT_APP_API_BASE_URL;
